import classNames from 'classnames'

import classes from '../BusinessDashboard.module.scss'
import { ReactComponent as MoneyCheckCircle } from '../../../../../assets/images/common/icons/flag-icon-round.svg'
import PropTypes from 'prop-types'
import ButtonLink from '../../../../common/buttons/ButtonLink'

export const EXCEPTION_CASE = {
  NO_ENROLLMENTS: 'NO_ENROLLMENTS',
  NO_PROGRAMS: 'NO_PROGRAMS',
}

const Placeholder = ({ exceptionCase }) => {
  const title = exceptionCase === EXCEPTION_CASE.NO_ENROLLMENTS ? 'No Enrollments' : 'No Programs or Enrollments'
  const linkText = exceptionCase === EXCEPTION_CASE.NO_ENROLLMENTS
    ? 'Need help marketing your programs?'
    : 'Learn how to get your programs live.'
  const linkHref = exceptionCase === EXCEPTION_CASE.NO_ENROLLMENTS
    ? 'https://intercom.help/op-36/en/articles/11144149-onboarding-101-announce-programs'
    : 'https://intercom.help/op-36/en/articles/11144105-onboarding-101-create-group-classes'

  return (
    <div className={classNames('d-flex flex-column justify-content-center align-items-center text-center', classes.placeholder)}>
      <MoneyCheckCircle className={classes.icon} />
      <h3 className={classNames('my-3', classes.noActivitiesTitle)}>{title}</h3>
      <p className={classes.noActivitiesText}>
        This dashboard will come to life once you start registering golfers. Make sure your programs are published and have pricing packages attached.
      </p>
      <ButtonLink
        navigateTo='/programs'
        noTopMargin
        className={classes.placeholderButton}
      >
        View Programs
      </ButtonLink>
      <a
        className='mt-2'
        href={linkHref}
        target='_blank'
      >
        {linkText}
      </a>
    </div>
  )
}

Placeholder.propTypes = {
  exceptionCase: PropTypes.oneOf([EXCEPTION_CASE.NO_ENROLLMENTS, EXCEPTION_CASE.NO_PROGRAMS]).isRequired,
}

export default Placeholder
